class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this._dgDetailsBound = false;
    this._dgDetailsRetryScheduled = false;
    this.bindDetailsDisclosure();
  }

  connectedCallback() {
    if (this.bindDetailsDisclosure() || this._dgDetailsRetryScheduled) return;
    this._dgDetailsRetryScheduled = true;

    Promise.resolve().then(() => {
      this._dgDetailsRetryScheduled = false;
      this.bindDetailsDisclosure();
    });
  }

  bindDetailsDisclosure() {
    if (this._dgDetailsBound) return true;
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle?.querySelector('summary') || null;
    this.content = this.summary?.nextElementSibling || null;

    if (!this.mainDetailsToggle || !this.summary || !this.content) return false;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this._dgDetailsBound = true;
    return true;
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle || !this.summary) return;
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
